import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getLocalDate } from '@skytech/utils'

import { useProfile } from '@/hooks/user'

export const useLocalDate = () => {
  const profile = useProfile()

  const formatDate = ({ date, locale }: { date: string | Date | null; locale?: Locale }) =>
    getLocalDate({
      date,
      locale: locale || profile?.locale || DEFAULT_LOCALE,
    })

  return { formatDate }
}
